export default __webpack_public_path__ + "static/media/lion.8c223996.png";